import { Component } from '@angular/core';
import { BaseModalDirective } from '@app/components/modals/base-modal';

@Component({
    templateUrl: './primary-caregivers.component.html',
    styleUrls: ['./primary-caregivers.component.scss'],
    standalone: false
})
export class PrimaryCaregiversModalComponent extends BaseModalDirective {}
